export default __webpack_public_path__ + "static/media/UI_SWITCH_Turn_On_04.b86e7be2.mp3";